import Lightbox from './Lightbox'

export default Lightbox
export * from './Lightbox'

export type { LightboxContentData } from './LightboxContent'
